import { type FC } from 'react'

import { useInitContactFormState } from '../../../../contact-form'
import { type OpenableControls } from '../../../../generic-hooks'
import { useDirectFormDialogContext } from '../DirectContactFormDialogContext'

import { DirectContactFormOtherTypeForm } from './DirectContactFormOtherTypeForm'

export const DirectContactFormDefaultCom: FC<{
  onFormSubmittedWithSuccess: () => void
  userModalControls: OpenableControls
}> = ({ onFormSubmittedWithSuccess, userModalControls }) => {
  const { product, subject } = useDirectFormDialogContext()

  const { formState } = useInitContactFormState({
    formSubject: subject,
    product,
  })

  formState.use()

  return (
    <DirectContactFormOtherTypeForm
      formState={formState}
      onFormSubmittedWithSuccess={onFormSubmittedWithSuccess}
      userModalControls={userModalControls}
    />
  )
}
